<template>
  <div class="ms-container">
    <amendments-page />
  </div>
</template>

<script>
import AmendmentsPage from '@/components/amendments/amendments-page'

export default {
  components: {
    AmendmentsPage
  }
}
</script>

<style></style>
